var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedbackAndSupportFeedback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#784ace;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feedback_and_support_feedback"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301,1C136.23,1,2.43,133.6,1,298.36A298.73,298.73,0,0,0,36.55,442.74a30.19,30.19,0,0,1,2.23,23.48L3.59,576.1A18.64,18.64,0,0,0,27,599.53L137.5,564.15a30.13,30.13,0,0,1,23.32,2.14A300.08,300.08,0,0,0,601,301C601,135.31,466.69,1,301,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.7,
    y: 328.45,
    width: 342.5,
    height: 93.62,
    rx: 46.81,
    transform: "translate(-2.84 2.3) rotate(-0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 129.35,
    y: 179.54,
    width: 342.64,
    height: 93.62,
    rx: 46.81,
    transform: "translate(-1.71 2.29) rotate(-0.43)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackAndSupportFeedback);
export default __webpack_public_path__ + "static/media/feedback_and_support_feedback.7c37f97e7cbacc0ece012b689f14440b.svg";
export { ForwardRef as ReactComponent };